import { c as _c } from "react/compiler-runtime";
import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/ui/utils';
export interface DrainedChipProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  /** Already-translated label string (e.g. `t('market.resolvedPanel.drainedChip')`). */
  label: string;
  className?: string | undefined;
}
const BASE_CLASS = 'inline-flex w-fit shrink-0 items-center rounded-pill whitespace-nowrap px-2 py-0.5 text-caption font-medium bg-background-tertiary text-foreground-tertiary';
export function DrainedChip(t0) {
  const $ = _c(10);
  let className;
  let label;
  let props;
  if ($[0] !== t0) {
    ({
      label,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = label;
    $[3] = props;
  } else {
    className = $[1];
    label = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn(BASE_CLASS, className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== label || $[7] !== props || $[8] !== t1) {
    t2 = <span data-slot="drained-chip" className={t1} {...props}>{label}</span>;
    $[6] = label;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}